import {HttpErrorResponse} from '@angular/common/http';
import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import { switchMap, tap} from 'rxjs/operators';
import {UIService} from 'src/app/_services/ui.service';
import {SigningProcessStep} from '../../_enums/signing-process-step.enum';
import {SigningProcess} from '../../_models/signing-process.model';
import {LocalStorageService} from '../../_services/local-storage.service';
import {SigningProcessStepService} from '../../_services/signing-process-steps.service';
import {SigningProcessService} from '../../_services/signing-process.service';
import {StyleServiceService} from 'src/app/_services/style-service.service';
import {ErrorPageService} from 'src/app/_services/error-page.service';
import {ErrorMessage} from 'src/app/_enums/error-message.enum';
import {InternalErrorCode} from 'src/app/_enums/internal-error-code.enum';
import {RestApiService} from '../../_services/rest-api.service';
import {Step} from '../../_enums/step.enum';
import {LogType} from '../../_enums/log-type.enum';
import {IdentityService} from '../../_services/identity.service';

@Component({
	selector: 'app-signing-process-container',
	templateUrl: './signing-process-container.component.html',
	styleUrls: ['./signing-process-container.component.css'],
})
export class SigningProcessContainerComponent implements OnInit {
	public useCredilowStyle: boolean;
	public completedStepper: boolean = false;
	public stepperState: string;
	public signingProcessStep: BehaviorSubject<SigningProcessStep> = new BehaviorSubject<SigningProcessStep>(
		SigningProcessStep.SigningProcessRedirect
	);
	private signingProcess: SigningProcess = new SigningProcess();
	public redirect: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	@ViewChild('stepper') stepper!: MatStepper;
	private authIdFromParams: number;
	private shouldMoveStepper: boolean = false;

	constructor(
		public styleService: StyleServiceService,

		private readonly route: ActivatedRoute,
		private readonly signingProcessService: SigningProcessService,
		private readonly signingProcessStepService: SigningProcessStepService,
		private readonly localStorageService: LocalStorageService,
		private readonly uIService: UIService,
		private errorPageService: ErrorPageService,
		private restApiService: RestApiService,
		private identityService: IdentityService,
		private cdr: ChangeDetectorRef,
		private router: Router
	) {
		this.route.queryParams.subscribe({
			next: (queryParams: Params) => {
				if (queryParams) {
					// si viene biometryId en los queryParams, es un FLD callback
					if (queryParams.biometryId) {
						// Check if this is an onboarding FLD callback
						const onboardingFld = sessionStorage.getItem('onboarding_fld');
						if (onboardingFld) {
							sessionStorage.removeItem('onboarding_fld');
							this.router.navigate(['/registro-resume'], {
								queryParams: { biometryId: queryParams.biometryId }
							});
							return;
						}
						this.redirect.next(false);
						this.signingProcessStepService.moveTo(SigningProcessStep.FLDRedirect);
					} else if (queryParams.url) {
						// flujo normal
						this.authIdFromParams = queryParams.authId;
						this.getDataForSigningProcess(atob(queryParams.url));
					}
				}
			},
			error: (error: Error) => console.log(error),
		});
	}

	public ngOnInit(): void {
		this.styleService.useCredilowStyle.subscribe((useCredilowStyle) => {
			this.useCredilowStyle = useCredilowStyle;
		});
		this.signingProcessStepService.step.subscribe({
			next: (signingProcessStep: SigningProcessStep) => {
				if (signingProcessStep) this.signingProcessStep.next(signingProcessStep);
			},
			error: (error: Error) => {
				console.log(error);
			},
		});
	}
	ngAfterViewChecked(): void {
		if (this.shouldMoveStepper && this.stepper) {
			this.stepper.next();
			this.shouldMoveStepper = false;
		}
	}
	private setSigningProcessData(data: any) {
		this.signingProcess.authId = data.authId;
		this.signingProcess.metodo_retiro = data.metodo_retiro;
		this.signingProcess.monto_cuota = data.monto_cuota;
		this.signingProcess.capital = data.capital;
		this.signingProcess.cantidad_cuotas = data.cantidad_cuotas;
		this.signingProcess.validationId = data.validationId;
		this.signingProcess.planId = data.planId;
		this.signingProcess.needsPep = data.needsPep;
		this.signingProcessService.setSigningProcess(this.signingProcess);
	}
	private getDataForSigningProcess(url: string) {
		this.signingProcessService.startSigningProcess(url).subscribe({
			next: (data: any) => {
				if (data.status !== 'error') {
					this.uIService.responseLog('startSigningProcess - OK');

					this.setSigningProcessData(data.dataForSignature);
					this.localStorageService.setToken(data.dataForSignature.jwt);
					this.uIService.responseLog('setToken - OK');
					this.sendMonitoringLog(data.dataForSignature.authId)
						.pipe(
							switchMap(() => this.identityService.createFLD(data.dataForSignature.validationId)),
							tap((fldResponse) => {
								this.restApiService
									.monitoringLog({creditFlowId: this.signingProcess.creditFlowId, step: Step.CreateFLD, logType: LogType.Flujo})
									.subscribe();
								this.redirect.next(true);
								// @TODO: este if es una mejora User Story 8014: FLD - Validar en la PWA cuando un usuario entra dos veces
								// queda comentado hasta que se haga esa tarjeta
								// if (fldResponse.alreadyValidated) {
								// 	this.signingProcessStepService.moveTo(SigningProcessStep.SignaturePad);
								// 	this.redirect.next(false);
								// 	this.shouldMoveStepper = true;
								// 	this.cdr.detectChanges();
								// }else{

								this.saveSessionData(data.dataForSignature, fldResponse);
								this.redirectToBiometry(fldResponse.redirectUrl);
								// }
							})
						)
						.subscribe({
							error: (error) => {
								this.restApiService
									.monitoringLog({creditFlowId: this.signingProcess.creditFlowId, step: Step.StartSigningProcess, logType: LogType.Consola, error: error})
									.subscribe();
								this.uIService.responseLog('Signing flow error', error);
								this.errorPageService.setError(
									error.error.message ?? null,
									error.error.payload.scalar ?? error.error.payload.message,
									error.error.code,
									null,
									error.error.errorId
								);
							},
						});
				} else {
					this.restApiService
						.monitoringLog({creditFlowId: this.signingProcess.creditFlowId, step: Step.StartSigningProcess, logType: LogType.Consola, error: data+url})
						.subscribe();
					this.uIService.responseLog('startSigningProcess - ERROR', data);
					this.errorPageService.setError(null, data.message);
				}
			},
			error: (error: HttpErrorResponse) => {
				this.uIService.responseLog('startSigningProcess - ERROR', error);
				this.restApiService
						.monitoringLog({creditFlowId: this.signingProcess.creditFlowId, step: Step.StartSigningProcess, logType: LogType.Consola, error: error})
						.subscribe();
				if (error.error.code == InternalErrorCode.InvalidMAC) {
					this.errorPageService.setError(null, ErrorMessage.InvalidMAC, error.error.code);
				} else if (error.error.code == InternalErrorCode.UserBlockedError || error.error.code == InternalErrorCode.CLIENT_NOT_VALIDATED) {
					this.errorPageService.setError(
						error.error.message ?? null,
						error.error.payload.scalar ?? error.error.message,
						error.error.code,
						null,
						error.error.errorId ?? null
					);
				} else {
					this.errorPageService.setError(
						error.error.message ?? null,
						error.error.payload.scalar ?? error.error.message,
						error.error.code,
						null,
						error.error.errorId ?? null
					);
				}
			},
		});
	}
	private sendMonitoringLog(authId: number): Observable<any> {
		return this.restApiService.monitoringLog({authId, step: Step.StartSigningProcess, logType: LogType.Flujo}).pipe(
			tap((data: any) => {
				this.signingProcess.creditFlowId = data.creditFlowId;
				this.signingProcessService.setSigningProcess(this.signingProcess);
			})
		);
	}

	private saveSessionData(signatureData: any, fldData: any) {
		const sessionInfo = {
			flowType: 'signing',
			authId: signatureData.authId,
			metodo_retiro: signatureData.metodo_retiro,
			monto_cuota: signatureData.monto_cuota,
			capital: signatureData.capital,
			cantidad_cuotas: signatureData.cantidad_cuotas,
			validationId: signatureData.validationId,
			planId: signatureData.planId,
			isId: fldData.sessionId,
			url: fldData.uri,
			creditFlowId: this.signingProcess.creditFlowId,
			needsPep: signatureData.needsPep,
		};

		sessionStorage.setItem(fldData.biometryId, JSON.stringify(sessionInfo));
		// @todo: en algun lugar dessetear esto!
	}

	private redirectToBiometry(redirectUri: string) {
		// this.redirect.next(false);
		window.location.href = redirectUri;
	}

	public changeStepperState(): void {
		this.stepper.next();
	}

	/**
	 * @description
	 *	Permite utilizar el enum en la vista HTML.
	 */
	public get SigningProcessStep(): typeof SigningProcessStep {
		return SigningProcessStep;
	}
}
